<template>
  <section class="layout">
    <!-- CONTENEDOR IMAGEN -->
    <div class="left-container">
      <img
        src="@/assets/form/logo.png"
        class="left-image"
        alt="Decoración Día Nacional del Cepillado"
      >
    </div>

    <!-- CONTENEDOR FORMULARIO -->
    <div class="right-container">
      <div class="form-wrapper">
        <h2 style="font-family: ColgateReady-Bold;">Formulario de inscripción</h2>

        <form @submit.prevent="submitForm">
          <!-- GRID EN 2 COLUMNAS PARA REDUCIR ALTURA -->
          <div class="form-grid">
            <div class="form-field">
              <label for="nombreInstitucion">Nombre institución</label>
              <input
                type="text"
                v-model="nombreInstitucion"
                id="nombreInstitucion"
                name="nombre-institucion"
                required
              >
            </div>

            <div class="form-field">
              <label for="nombreSede">Nombre sede (Opcional)</label>
              <input
                type="text"
                v-model="nombreSede"
                id="nombreSede"
                name="nombre-sede"
              >
            </div>

            <div class="form-field">
              <label for="codigoDaneNit">Código Dane o Nit</label>
              <input
                type="text"
                v-model="codigoDaneNit"
                id="codigoDaneNit"
                name="codigo"
                required
              >
            </div>

            <div class="form-field">
              <label for="correo">Correo electrónico</label>
              <input
                type="email"
                v-model="correo"
                id="correo"
                name="correo"
                required
              >
            </div>

            <div class="form-field">
              <label for="ciudad">Ciudad</label>
              <input
                type="text"
                v-model="ciudad"
                id="ciudad"
                name="ciudad"
                required
              >
            </div>

            <div class="form-field">
              <label for="departamento">Departamento</label>
              <input
                type="text"
                v-model="departamento"
                id="departamento"
                name="departamento"
                required
              >
            </div>
          </div>

          <!-- ARCHIVOS EN BLOQUE INDEPENDIENTE -->
          <div class="file-field">
            <label for="fotos">Subir evidencias</label>
            <input
              type="file"
              id="fotos"
              @change="handleFileUpload"
              multiple
              required
              accept="image/jpeg, image/png, image/jpg, image/webp"
            >
          </div>

          <!-- PREVIEW -->
          <div v-if="fotos.length" class="preview-wrapper">
            <h3>Previsualización de fotos:</h3>
            <div class="preview-box">
              <div
                class="preview-item"
                v-for="(foto, index) in previewImages"
                :key="index"
              >
                <button
                  type="button"
                  class="btn-remove-preview"
                  @click="removeImage(index)"
                  aria-label="Eliminar imagen"
                >
                  ×
                </button>
                <img
                  :src="foto"
                  alt="preview"
                >
              </div>
            </div>
          </div>

          <button type="submit" class="btn-submit">Enviar</button>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2'; // Importa SweetAlert2

export default {
  data() {
    return {
      nombreInstitucion: '',
      nombreSede: '',
      codigoDaneNit: '',
      correo: '',
      ciudad: '',
      departamento: '',
      fotos: [],  
      previewImages: []  
    };
  },
  methods: {
    handleFileUpload(event) {
      this.previewImages.forEach((url) => URL.revokeObjectURL(url));
      this.fotos = Array.from(event.target.files);  
      this.previewImages = this.fotos.map(file => URL.createObjectURL(file));  
    },
    removeImage(index) {
      const url = this.previewImages[index];
      if (url) URL.revokeObjectURL(url);

      this.previewImages.splice(index, 1);
      this.fotos.splice(index, 1);

      const input = document.getElementById("fotos");
      input.value = "";

      if (this.fotos.length > 0) {
        const dt = new DataTransfer();
        this.fotos.forEach(file => dt.items.add(file));
        input.files = dt.files; 
      }
    },
    async submitForm() {
      try {
        Swal.fire({
          title: 'Enviando...',
          text: 'Por favor espera mientras procesamos tu información.',
          icon: 'info',
          allowOutsideClick: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        const formData = new FormData();
        formData.append('nombreInstitucion', this.nombreInstitucion);
        formData.append('nombreSede', this.nombreSede);
        formData.append('codigoDaneNit', this.codigoDaneNit);
        formData.append('correo', this.correo);
        formData.append('ciudad', this.ciudad);
        formData.append('departamento', this.departamento);

        this.fotos.forEach((file) => {
          formData.append('fotos', file);
        });

        const response = await axios.post('https://dia-nacional-cepillado-sbfb2024.col1.co/api/forms', formData, {  
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        Swal.fire({
          title: 'Su inscripción ha sido exitosa',
          text: 'Muchas gracias por participar en el día nacional del cepillado 2024',
          icon: 'success',
          confirmButtonText: 'OK'
        });

        this.nombreInstitucion = '';
        this.nombreSede = '';
        this.codigoDaneNit = '';
        this.correo = '';
        this.ciudad = '';
        this.departamento = '';
        this.fotos = [];
        this.previewImages.forEach((url) => URL.revokeObjectURL(url));
        this.previewImages = [];

      } catch (error) {
        console.error('Error al enviar el formulario', error);
        Swal.fire({
          title: 'Error',
          text: 'Error al enviar el formulario. Por favor, inténtalo nuevamente.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      }
    }
  }
};
</script>

<style scoped>
/* ----- DESKTOP / PANTALLAS GRANDES ----- */
.layout {
  display: flex;
  width: 100%;
  min-height: 100vh;
}

/* Contenedor imagen */
.left-container {
  width: 50%;
  position: relative;
}

.left-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 60%;
  max-width: 420px;
  height: auto;
}

/* Contenedor formulario */
.right-container {
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

/* Caja del formulario */
.form-wrapper {
  background: #F7CACB;
  padding: 24px 24px;
  border-radius: 20px;
  width: 80%;
  max-width: 520px; /* un poco más ancho para 2 columnas */
  box-shadow: 0px 5px 25px rgba(0,0,0,0.15);
  margin: 32px 0;
  max-height: calc(100vh - 64px); /* menos alto para evitar scroll general */
  overflow-y: auto;               /* si se pasa, scroll interno */
}

/* GRID EN 2 COLUMNAS PARA CAMPOS DE TEXTO */
.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 20px;
  row-gap: 8px;
}

.form-field {
  display: flex;
  flex-direction: column;
}

/* Campo archivos ocupa todo el ancho */
.file-field {
  margin-top: 16px;
}

/* Título */
h2 {
  text-align: center;
  color: #5A1A8C;
  margin-bottom: 20px;
  font-weight: bold;
}

label {
  font-size: 15px;
  margin-bottom: 4px;
  color: #4F4F4F;
  font-family: Arial, Helvetica, sans-serif;
}

input[type="text"],
input[type="email"],
input[type="file"] {
  width: 100%;
  border: none;
  border-bottom: 2px solid #7A7A7A;
  background: transparent;
  padding: 6px 0;
  font-size: 15px;
  color: #333;
  outline: none;
}

/* Preview imágenes */
.preview-wrapper {
  margin-top: 16px;
}

.preview-box {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 8px;
}

.preview-box img {
  width: 90px;
  height: 90px;
  object-fit: cover;
  border-radius: 8px;
}

.preview-item {
  position: relative;
  width: 90px;
  height: 90px;
}

.preview-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.btn-remove-preview {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: none;
  background: #D8232A;
  color: #fff;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  cursor: pointer;
  padding: 0;
}

.btn-submit {
  background: #D8232A;
  color: white;
  font-size: 18px;
  font-weight: bold;
  border: none;
  width: 100%;
  padding: 10px;
  border-radius: 25px;
  margin-top: 20px;
  cursor: pointer;
}

.btn-submit:hover {
  background: #b51c21;
}

/* ----- MOBILE / TABLET ----- */
@media (max-width: 900px) {
  .layout {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    min-height: 100dvh;
  }

  .left-container,
  .right-container {
    width: 100%;
  }

  .left-image {
    position: relative;
    top: 0;
    left: 0;
    width: 85%;
    max-width: 320px;
    margin: 0;
  }

  .right-container {
    justify-content: center;
    align-items: flex-start;
    padding-top: 16px;
    padding-bottom: 16px;
  }

  .form-wrapper {
    width: 90%;
    max-width: 460px;
    margin: 24px auto;
    max-height: none;
  }

  /* En móviles, el formulario vuelve a 1 columna para mejor lectura */
  .form-grid {
    grid-template-columns: 1fr;
  }
}

/* ---- Imagen mucho más grande en pantallas amplias ---- */
@media (min-width: 1300px) {
  .left-image {
    width: 95%;
    max-width: 750px;
  }
}

@media (min-width: 1600px) {
  .left-image {
    width: 110%;
    max-width: 900px;
  }
}

@media (min-width: 2000px) {
  .left-image {
    width: 130%;
    max-width: 1100px;
  }
}

@media (min-width: 2400px) {
  .left-image {
    width: 150%;
    max-width: 1400px;
  }
}
</style>